import { createServerFn } from "@tanstack/react-start";
import { negotiateLocale } from "shared/Locale";
import { getRequest } from "src/lib/RequestState";

/**
 * The portal language the visitor's browser asks for (`Accept-Language`), for people who haven't
 * chosen one. On client-side navigations the RPC carries the same header from the browser.
 */
export const getBrowserLocale = createServerFn({ method: "GET" }).handler(() =>
  negotiateLocale(getRequest()?.headers.get("Accept-Language")),
);
